"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _QRCode = require("./components/QRCode");
Object.keys(_QRCode).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _QRCode[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _QRCode[key];
    }
  });
});
var _QRCodeImg = require("./components/QRCodeImg");
Object.keys(_QRCodeImg).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _QRCodeImg[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _QRCodeImg[key];
    }
  });
});